import { render, staticRenderFns } from "./MessageReceptors.vue?vue&type=template&id=49b8ed58&scoped=true"
import script from "./MessageReceptors.vue?vue&type=script&lang=js"
export * from "./MessageReceptors.vue?vue&type=script&lang=js"
import style0 from "./MessageReceptors.vue?vue&type=style&index=0&id=49b8ed58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b8ed58",
  null
  
)

export default component.exports